import { useMutation, MutationFunction } from '@tanstack/react-query';

import { postUserLogin } from 'services';

import type { AuthPayload, AuthCredentials } from 'domains/auth';

const userLoginTyped: MutationFunction<AuthPayload, AuthCredentials> = postUserLogin;

export const useLogin = () => {
  return useMutation<AuthPayload, Error, AuthCredentials>(userLoginTyped);
};
